import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=2c452612&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=2c452612&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c452612",
  null
  
)

export default component.exports